export const TZ_UPDATE_USER_TIMEZONE = 'TZ_UPDATE_USER_TIMEZONE';
export const TZ_UPDATE_USER_TIMEZONE_RESULT = 'TZ_UPDATE_USER_TIMEZONE/result';
export const TZ_UPDATE_USER_TIMEZONE_ERROR = 'TZ_UPDATE_USER_TIMEZONE/error';
